import env from "../../../env";

export default {
  pcode: env.OOYALA_PCODE || 'lham0yOhn5VvLeBHrySRvf4ruRyC',
  playerBrandingId: env.OOYALA_BRANDING_ID || '8bcc8b5507b349b8b13d153891e44c60',
  autoplay: false,
  loop: false,
  skin: {
    config: "/ooyala-skin/assets/spl-skin.json",
  }
};



// WEBPACK FOOTER //
// ./modules/Ooyala/component/playerParams.js